import type { EndCoordsSlice, EndCoordsState, ViewerSliceCreator } from "./types";

export const endCoordsInitialState: EndCoordsState = {
  endCoordsList: [],
  availableLinks: [],
  hiddenEndCoords: {},
};

export const createEndCoordsSlice: ViewerSliceCreator<EndCoordsSlice> = (set) => ({
  ...endCoordsInitialState,

  setEndCoordsList: (msg) =>
    set((state) => {
      state.endCoordsList = msg.end_coords_list;
    }),

  setAvailableLinks: (msg) =>
    set((state) => {
      state.availableLinks = msg.links;
    }),

  toggleEndCoordsVisibility: (name: string) =>
    set((state) => {
      if (state.hiddenEndCoords[name]) {
        delete state.hiddenEndCoords[name];
      } else {
        state.hiddenEndCoords[name] = true;
      }
    }),
});
